export enum ProfileReduxActions {
  SET_SBL_PROFILE = "SET_SBL_PROFILE",
  SET_RND_PROFILE = "SET_RND_PROFILE",
  SWITCH_PROFILE_LOAN_TYPE = "SWITCH_PROFILE_LOAN_TYPE",
  BROKER_APP_DIALOG = "BROKER_APP_DIALOG",
}

const setSblProfile = (payload: any): any => ({
  type: ProfileReduxActions.SET_SBL_PROFILE,
  payload,
});

const setRndProfile = (payload: any): any => ({
  type: ProfileReduxActions.SET_RND_PROFILE,
  payload,
});

const switchProfileLoanType = (payload: "sbl" | "rnd"): any => ({
  type: ProfileReduxActions.SWITCH_PROFILE_LOAN_TYPE,
  payload,
});

const brokerAppDialog = (payload): any => ({
  type: ProfileReduxActions.BROKER_APP_DIALOG,
  payload,
});

export const ProfileActions = {
  setSblProfile,
  setRndProfile,
  switchProfileLoanType,
  brokerAppDialog,
};
